(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Bin', Bin);

    Bin.$inject = ['$resource'];

    function Bin ($resource) {
        var resourceUrl =  'api/bins/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
